import { render } from "./imageUrl.vue?vue&type=template&id=779cb21c&scoped=true"
import script from "./imageUrl.vue?vue&type=script&lang=js"
export * from "./imageUrl.vue?vue&type=script&lang=js"

import "./imageUrl.vue?vue&type=style&index=0&id=779cb21c&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779cb21c"]])

export default __exports__